import axios from "axios";
// import AppConfig from '../../../AppConfig';
import getAxiosConfig from "@src/utils/getAxiosConfig";
import apiEndPoints from "./apiEndpoints";
export async function getJwpSignedUrl(vidKey, hashKey, item) {
  hashKey = hashKey
    ? hashKey
    : "eyJjb3Vyc2VJZCI6IjUyMDk3IiwidHV0b3JJZCI6bnVsbCwib3JnSWQiOjE3MCwiY2F0ZWdvcnlJZCI6bnVsbH0=";

  // let vidUrl = item
  //   ? item.url
  //   : `https://cdn.jwplayer.com/manifests/${vidKey}.m3u8`;

  return new Promise((resolve, reject) => {
    try {


      axios({
        ...getAxiosConfig(
          apiEndPoints["GET_SIGNED_URL"]?.method,
          apiEndPoints["GET_SIGNED_URL"]?.url,
          { item: item },
          null,
          null,
          null,
          { "x-access-token": hashKey, "mobile-agent": "Mobile-Android", webToken: true }
        ),
      })
        .then((response) => {
          var result = response.data;
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    }
    catch (err) {
      console.log(err)
    }
    // axios
    //   .get(
    //     `${"https://api.classplusapp.com"}/cams/uploader/video/jw-signed-url?url=${vidUrl}`,
    //     {
    //       headers: {
    //         "x-access-token": hashKey,
    //       },
    //     }
    //   )
    //   .then((response) => {
    //     var result = response.data;
    //     resolve(result);
    //   })
    //   .catch((err) => {
    //     reject(err);
    //   });
  });
}
